import RNFS from 'react-native-fs'
import DocumentPicker from 'react-native-document-picker'
import { launchCamera, launchImageLibrary } from 'react-native-image-picker'
import {
  getLocalizedText,
  fileTooLargeMessages,
  missingFileMessages,
  closeMessages,
  takePhotoMessages,
  chooseFromLibraryMessages,
  youCanChooseOneImageMessages,
  cancelMessages,
  fileMessages,
  chooseFileTypeMessages,
  photoVideoMessages,
} from './languageLocale'
import { Alert } from './alerts'
import { dataLimit } from './numbers'

export const ImagePicker = {
  showImagePicker: (options, response) => {
    Alert.alert(
      getLocalizedText(youCanChooseOneImageMessages).body,
      null,
      [
        {
          text: getLocalizedText(takePhotoMessages).body,
          onPress: () => launchCamera(options, response),
        },
        {
          text: getLocalizedText(chooseFromLibraryMessages).body,
          onPress: () => launchImageLibrary(options, response),
        },
        {
          text: getLocalizedText(cancelMessages).body,
          style: 'cancel',
        },
      ],
      {
        cancelable: true,
      }
    )
  },
}

export const FilePicker = {
  showFilePicker: callback => {
    Alert.alert(getLocalizedText(chooseFileTypeMessages).body, null, [
      {
        text: getLocalizedText(photoVideoMessages).body,
        onPress: async () => {
          try {
            const response = await launchImageLibrary({
              quality: 0.7,
              mediaType: 'mixed',
              noData: true,
            })

            if (response.error) {
              return Alert.alert('Error', response.error)
            }

            const asset = response && response.assets && response.assets[0]
            if (!asset || !asset.uri) {
              return
            }

            const size =
              typeof asset.fileSize === 'number' ? asset.fileSize : undefined
            if (typeof size === 'number' && checkFileSize(size)) {
              return
            }

            const previewURI = asset.uri
            const data = await RNFS.readFile(previewURI, 'base64')
            const filename =
              asset.fileName ||
              response.fileName ||
              previewURI.split('/').slice(-1)[0]
            callback({ filename, data })
          } catch (err) {
            Alert.alert('Error: ', err.message)
          }
        },
      },
      {
        text: getLocalizedText(fileMessages).body,
        onPress: async () => {
          try {
            const pickedRaw =
              typeof DocumentPicker.pickSingle === 'function'
                ? await DocumentPicker.pickSingle()
                : await DocumentPicker.pick()

            const result = Array.isArray(pickedRaw) ? pickedRaw[0] : pickedRaw
            if (!result || !result.uri) {
              return
            }

            const size =
              typeof result.size === 'number' ? result.size : undefined
            const isFileTooLarge =
              typeof size === 'number' ? checkFileSize(size) : false
            const fileExists = await checkFileExists(result.uri)

            if (isFileTooLarge || !fileExists) {
              // no-op
            } else {
              const uriToRead =
                typeof result.uri === 'string' &&
                result.uri.indexOf('content://') === 0
                  ? result.uri
                  : decodeURI(result.uri)
              const data = await RNFS.readFile(uriToRead, 'base64')

              callback({
                data,
                filename: result.name || result.fileName,
              })
            }
          } catch (err) {
            console.log('ERROR picking document:', err)
          }
        },
      },
      {
        text: getLocalizedText(cancelMessages).body,
        style: 'cancel',
      },
    ])
  },
}

const checkFileSize = size => {
  if (size >= dataLimit) {
    const { title, body } = getLocalizedText(fileTooLargeMessages)
    const { body: closeMsg } = getLocalizedText(closeMessages)

    Alert.alert(title, body, [
      {
        text: closeMsg,
        style: 'cancel',
      },
    ])

    return true
  }
  return false
}

const checkFileExists = async uri => {
  const path =
    typeof uri === 'string' && uri.indexOf('content://') === 0
      ? uri
      : decodeURI(uri)
  const fileExists = await RNFS.exists(path)
  if (!fileExists) {
    const { title, body } = getLocalizedText(missingFileMessages)
    const { body: closeMsg } = getLocalizedText(closeMessages)
    Alert.alert(title, body, [
      {
        text: closeMsg,
        style: 'cancel',
      },
    ])

    return false
  }
  return true
}
